<template>
  <div>
    <breadcrumb :routerList="[{to:'/dingd/dingdwxlistUsa',title:'订单管理'},{title:'创建订单'}]"/>
    <div class="h-piece ddform_disable_cls">
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>订单信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order"
                     class="demo-ruleForm h-formbLine">
              <el-form-item label="订单类型" class="h-elformWrap-2">
                <el-input v-model="xsqyStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="this.order.cuname" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建时间" class="h-elformWrap-2">
                <el-input v-model="this.order.cdate" readonly></el-input>
              </el-form-item>
              <el-form-item label="销售组织" class="h-elformWrap-2">
                <el-input v-model="xszzStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="分销渠道" class="h-elformWrap-2">
                <el-input v-model="fxqdStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="报价单" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传报价单', trigger: 'change'},
							]">
                <brupload
                    :refid=order.id
                    reftype="订单-外销项目-PI"
                    :limit="1"
                    :showtime="false"
                    uploadflag
                    delflag
                >
                </brupload>
              </el-form-item>
              <el-form-item label="PO凭证" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传PO凭证', trigger: 'change'},
							]">
                <brupload
                    :refid=order.id
                    reftype="订单-外销项目-PO"
                    :limit="1"
                    :showtime="false"
                    uploadflag
                    delflag
                >
                </brupload>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>客户信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form1" label-position="right" :inline="true"
                     class="demo-ruleForm h-formbLine">
              <el-form-item prop="soldToName" label="售达方名称"
                            :rules="[
								  { required: true, message: '请输入售达方名称', trigger: 'input'},
								]" class="h-elformWrap-2">
                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                  <i
                      v-if="selectDailishang"
                      class="el-icon-search el-input__icon"
                      slot="suffix"
                      @click="openShoudf">
                  </i>
                </el-input>
              </el-form-item>

              <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2">
                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
              </el-form-item>
              <el-form-item prop="shipToAreaCode" label="送达方区域"   :rules="[
								  { required: true, message: '送达方区域不能为空', trigger: 'change'},
								]" class="h-elformWrap-2">
                <el-select v-model="order.shipToAreaCode" :v="order.shipToAreaCode" filterable placeholder="请选择" style="width:100%" @change="getAreaList">
                  <el-option v-for="(item,index) in QYcountryList"
                             :key="index" :label="`[${item.gjcode}]${item.gjname}`" :value="item.gjcode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="toCompanyname" label="港口" :rules="[
								  { required: true, message: '港口不能为空', trigger: 'input'},
								]"  class="h-elformWrap-2">
                <el-input v-model="order.toCompanyname" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item prop="gjmytk" label="国际贸易条款" :rules="[
								  { required: true, message: '请输入国际贸易条款', trigger: 'change'},
								]"   class="h-elformWrap-2">
                <brselect clearable category="YlCommercialTerms" :v="order.gjmytk" :showcode="true"
                          @change="ruleC" v-model="order.gjmytk"></brselect>
              </el-form-item>

              <el-form-item prop="fktj" label="付款条件" :rules="[
								  { required: true, message: '请输入付款条件', trigger: 'change'},
								]"   class="h-elformWrap-2">
                <brselect clearable category="DD_FKTJ" :v="order.fktj" :showcode="true" @change="changeFktj"
                          v-model="order.fktj"></brselect>
              </el-form-item>

              <el-form-item prop="currencyCode" label="币种" :rules="[
								  { required: true, message: '请输入币种', trigger: 'change'},
								]"   class="h-elformWrap-2">
                <mdmselect clearable category="YLCurrency"
                           :showcode="true"
                           disabled
                           :v="order.currencyCode" @change="changeCurrencyCode"
                           v-model="order.currencyCode"></mdmselect>
              </el-form-item>

            <!--  <el-form-item prop="kucun" label="库位" :rules="[
								  { required: true, message: '请选择库位', trigger: 'change'},
								]"   class="h-elformWrap-2">
                <brselect clearable category="order_wx_kuwei_usa"
                          :v="order.kucun"
                          v-model="order.kucun"></brselect>
              </el-form-item>-->

              <el-form-item prop="boxing" label="装箱方式" :rules="[
								  { required: true, message: '请选择装箱方式', trigger: 'change'},
								]"   class="h-elformWrap-2">
                <brselect clearable category="zhuangxiang"
                          :v="order.boxing"
                          v-model="order.boxing"></brselect>
              </el-form-item>

              <el-form-item prop="attachment" label="是否有备件" :rules="[
								  { required: true, message: '请选择是否有备件', trigger: 'change'},
								]"   class="h-elformWrap-2">
                <brselect clearable category="shifou_keyong"
                          :v="order.attachment"
                          v-model="order.attachment"></brselect>
              </el-form-item>
              <el-form-item label="船期日期" class="h-elformWrap-2" :rules="[
								  { required: true, message: '船期日期不能为空', trigger: 'change'},
								]">
                <el-date-picker v-model="order.shipDate" type="date"
                                class="h-tableInput" :clearable="false"
                                :picker-options="pickerOptions"
                                placeholder="请选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="overseaShname" label="境外收货人" :rules="[
								  { required: true, message: '境外收货人不能为空', trigger: 'input'},
								]"  class="h-elformWrap-2">
                <el-input v-model="order.overseaShname" placeholder="请输入"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <!--售达方-->
      <shoudf :visible.sync="showshdfdialog"
              v-if="showshdfdialog"
              @choseObj="choseshoudf"
              oneflag
              :usercode="currentUser"
              :ddlx="ddlx"
              :xszz="order.saleGroupCode"
              title="选择售达方"/>

      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <div class="h-table h-mrt30 ljjtablepaddings3" style="margin: 20px 20px 0 20px;">
        <div class="h-pieceTitle2 message">
          <h1 class="h1">产品信息</h1>
          <el-button size="small" type="primary"
                     icon="el-icon-circle-plus"
                     style="margin-left: 50px;"
                     @click="showProcuct1" v-if="showaddProductRow">选择产品
          </el-button>
          <span style="color: red;font-size: 12px;display: inline-block;padding-left: 20px;">计算逻辑已经修改，请直接填写成交价</span>
        </div>
        <el-table
            ref="multipleTable"
            :data="productlist1"
            stripe
            border
            style="width: 100%">
          <el-table-column
              type="index"
              fixed
              label="#"
              width="40">
          </el-table-column>
          <el-table-column
              prop="proModelName"
              label="产品大类"
              :show-overflow-tooltip="true"
              fixed
              min-width="90">
          </el-table-column>
          <el-table-column
              prop="materialCode"
              label="产品编码"
              :show-overflow-tooltip="true"
              fixed
              min-width="110">
          </el-table-column>
          <el-table-column
              prop="materialName"
              min-width="200"
              :show-overflow-tooltip="true"
              fixed
              label="产品名称">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.materialName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="oemDesc"
              min-width="160"
              :show-overflow-tooltip="true"
              label="规格型号">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.oemDesc}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="factory"
              label="产地"
              min-width="100">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.factory}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="currencyCode"
              label="币种"
              min-width="90">
          </el-table-column>
          <el-table-column
                  min-width="110"
                  prop="kucun"
                  :show-overflow-tooltip="true"
                  label="库位">
            <template slot-scope="scope">
              <brselect clearable category="order_wx_kuwei" v-show="scope.row.materialType != 'UNBW'"
                        :v="scope.row.kucun"
                        v-model="scope.row.kucun"></brselect>
            </template>
          </el-table-column>
          <el-table-column label="业务类型" v-if="guanliren" min-width="100">
            <template slot-scope="scope" v-if="scope.row.proType=='OEM'">
              <el-select v-model="scope.row.zhifakufa" :clearable="true" :disabled="scope.row.tianman==true" placeholder="请选择">
                <el-option label="直发" :value="1"></el-option>
                <el-option label="库发" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
              prop="expoPrice"
              label="销售单价"
              min-width="120" >
            <template slot-scope="scope">
              <div v-if="showIsFree" style="text-align: right;">
                {{ scope.row.expoPrice = new big(scope.row.finalPrice||0).minus(scope.row.feeyongj||0 ).minus( scope.row.feebaof||0 ).minus( scope.row.feeyunf||0).toFixed(2) }}
              </div>
              <div v-else style="text-align: right;">
                {{ scope.row.expoPrice = new big(scope.row.finalPrice||0).minus(scope.row.feeyongj||0).minus(scope.row.feebaof||0).minus(scope.row.feeyunf||0).toFixed(2) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="feeyongj"
              label="佣金/单台"
              min-width="110">
            <template slot-scope="scope">
              <el-input v-model="scope.row.feeyongj"
                        placeholder="请输入"
                        @keyup.native='keyupEvent($event,input)'
                        :readonly="scope.row.expoPriceReadonly"
                        class="DshuR h-tableInput" auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column
              v-if="showFee"
              prop="feebaof"
              label="保费/单台"
              min-width="110">
            <template slot-scope="scope">
              <el-input v-model="scope.row.feebaof"
                        placeholder="请输入"
                        @keyup.native='keyupEvent($event,input)'
                        :readonly="scope.row.expoPriceReadonly"
                        class="DshuR h-tableInput" auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column
              v-if="showFee"
              prop="feeyunf"
              label="运费/单台"
              min-width="110">
            <template slot-scope="scope">
              <el-input v-model="scope.row.feeyunf"
                        placeholder="请输入"
                        @keyup.native='keyupEvent($event,input)'
                        :readonly="scope.row.expoPriceReadonly"
                        class="DshuR h-tableInput" auto-complete="off"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="proNumber" label="订单数量" min-width="80">
            <template slot-scope="scope">
              <el-input v-model="scope.row.proNumber"
                        oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
                        placeholder="请输入"
                        class="DshuR h-tableInput" auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="proBenchmarkPrice" :label="priceName" :show-overflow-tooltip="true" min-width="70">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.proBenchmarkPrice}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="finalPrice" label="成交价" min-width="80">
            <template slot-scope="scope">
              <el-input v-model="scope.row.finalPrice"
                        placeholder="请输入"
                        @keyup.native='keyupEvent($event,input)'
                        @input="bindInputNum2(scope.row,'CJJ')"
                        :readonly="scope.row.expoPriceReadonly"
                        class="DshuR h-tableInput" auto-complete="off"></el-input>
            </template>
          </el-table-column>

          <el-table-column
              prop="totalprice"
              label= "总价"
              min-width="120"
          >
            <template slot-scope="scope">
              <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber || 0).times(scope.row.finalPrice||0).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="hjmaozh"
              :label="`毛重/${dwzhiliang}`"
              min-width="100"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{   scope.row.hjmaozh = new big(scope.row.proNumber || 0).times(scope.row.wlmaozh||0)}}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="hjjinzh"
              :label="`净重/${dwzhiliang}`"
              min-width="100"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{  scope.row.hjjinzh = new big(scope.row.proNumber || 0).times(scope.row.wljinzh||0) }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="hjtiji"
              :label="`体积/${dwtiji}`"
              min-width="100"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{  scope.row.hjtiji = new big(scope.row.proNumber || 0).times(scope.row.wltiji) }}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="measure"
              label="尺寸(长宽高)"
              :show-overflow-tooltip="true"
              min-width="110">
          </el-table-column>
          <el-table-column
              prop="note1"
              label="备注"
              min-width="160"
          >
            <template slot-scope="scope">
              <el-input class="h-tableInput" v-model="scope.row.note1"
                        placeholder=""
                        auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteThis2(scope.$index,scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="background-color: rgb(94, 182, 233);" v-if="showaddProductRow" @click="showProcuct1">
          <img src="../../assets/images/pimg/jiahao.png" alt="">
        </div>
        <div class="jieguo" v-if="!showIsFree">
          <span class="jieguo_label">{{order.currencyCode || ''}}总价</span>
          <span class="jieguo_value">
                    {{ order.orderPrice }}
                </span>

          <span class="jieguo_label" style="width: 2rem;">RMB总价</span>
          <span class="jieguo_value">{{ order.orderPriceRbm }}</span>

          <span class="jieguo_label" v-show="needxinjin">现金余额</span>
          <span class="jieguo_value" v-show="needxinjin">{{ this.cashBalance }}</span>

          <span class="jieguo_label" v-show="needxinjin">现金占用</span>
          <!--                <span class="jieguo_value">{{ order.orderPriceXj = (this.cashBalance-order.orderPriceRbm<=0?this.cashBalance:order.orderPriceRbm)}}</span>-->
          <span class="jieguo_value" v-show="needxinjin">{{ order.orderPriceXj = this.needxinjin?(order.orderPrice||0):0}}</span>

          <span class="jieguo_label" v-show="needxindai">信贷选择</span>
          <span class="jieguo_value" v-show="needxindai">
                    <el-select class="ljjsales" v-model="order.creditid" clearable
                               placeholder="请选择" @change="creditChange">
                        <el-option v-for="item in creditData"
                                   :key="item.id"
                                   :label="item.cid!=null ? `信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`:'请选择'"
                                   :value="item.id">
                            <div style="color: #8492a6; font-size: 12px"  v-if="item.cid!=null">
                                <i style="float: left">{{ item.creCategory==1?'中信保':item.creCategory==0?'内部专属信贷':item.creCategory==2?'内部通用信贷':'' }} {{item.cid==null ? '':'('+item.cid+')'}}&nbsp;</i>&nbsp;
                                <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                <i style="float: right; ">信贷账期：{{ item.paymentdate }}天</i>
                            </div>
                        </el-option>
                    </el-select>
                </span>
          <span class="jieguo_label" v-show="needxindai">信贷占用</span>
          <span class="jieguo_value" v-show="needxindai">{{ order.orderPriceXd }}</span>

          <span class="jieguo_label">净价值</span>
          <span class="jieguo_value">{{(order.orderNetWorth = order.orderPrice )}}</span>
        </div>
        <div class="jieguo" v-if="!showIsFree">
          <span class="jieguo_label" style="width: 2rem;">总件数</span>
          <span class="jieguo_value">{{ order.allNum }}</span>
          <span class="jieguo_label">毛重汇总/{{this.dwzhiliang}}</span>
          <span class="jieguo_value">{{ order.allhjmaozh }}</span>
          <span class="jieguo_label">净重汇总/{{this.dwzhiliang}}</span>
          <span class="jieguo_value">{{(order.allhjjinzh )}}</span>
          <span class="jieguo_label">体积汇总/{{this.dwtiji}}</span>
          <span class="jieguo_value">{{order.allhjtiji }}</span>
          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
        </div>
        <div class="jieguo">
          <span class="jieguo_label">总佣金合计</span>
          <span class="jieguo_value">{{ order.allfeeyongj }}</span>
          <span class="jieguo_label" v-if="showFee">总保费合计</span>
          <span class="jieguo_value" v-if="showFee">{{(order.allfeebaof )}}</span>
          <span class="jieguo_label" v-if="showFee">总运费合计</span>
          <span class="jieguo_value" v-if="showFee">{{order.allfeeyunf }}</span>
          <span class="jieguo_label" style="background: transparent;" v-if="!showFee"></span>
          <span class="jieguo_value" v-if="!showFee"></span>
          <span class="jieguo_label" style="background: transparent;" v-if="!showFee"></span>
          <span class="jieguo_value" v-if="!showFee"></span>

          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
          <span class="jieguo_label" style="background: transparent;"></span>
          <span class="jieguo_value"></span>
        </div>
      </div>
      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <!--物料-->
      <wxwl :visible.sync="showwuliaodialog"
                      v-if="showwuliaodialog"
                      @choseObj="bindChoseWuliao"
                      :ddlx="ddlx"
                      :xmcode="xmcode"
                      :usercode="order.soldToCode"
                      :currencyCode="order.currencyCode"
                      :country="order.shipToAreaCode"
                      title="选择物料"/>

      <div>
        <div class="anniu" >
          <el-button class="h-btn h-bBtn h-bgwhite"  @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import ss from "@/api/SystemService";
import shoudf from "@/components/dialog/selectshdf.vue";
import wxwl from '../../components/dialog/wxwl'
import big from "big.js";
import _ from "loadsh";

export default {
  components: {wxwl, shoudf},
  data(){
    return{
      order:{
        shipDate:null,
        businessUser:null,
        businessArea:null,
        kucun:null,//库存地点
        sapcode:null,//订单编码
        id:null, // 主键
        orderMainContract:null, // 主合同编号
        orderSubContract:null, // 分合同编号
        orderProjectCode:null, // 项目编号
        orderProjectName:null, // 项目名称
        orderCategory:null, // 订单类型
        orderCategory1:null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
        saleGroupCode:null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
        disChannelCode:null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
        zCode:null, // 分销渠道编码-子编码
        customerChannelCode:null, // 客户渠道
        isStockUp:null, // 是否备货      1：是；0：否
        orderStatus:null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
        instid:null, // 流程id
        taskId:null, // 流程id
        tuihyy:null, // 退货原因
        tuihyydes:null, // 退货原因说明
        contactName:null, // 联系人名称
        receivedTime:null, // 预计收货时间
        soldToCode:null, // 售达方编码
        soldToName:null, // 售达方名称
        soldToAreaCode:null, // 售达方地区编码
        soldToAreaName:null, // 售达方地区名称
        shipToCode:null, // 送达方编码
        shipToName:null, // 送达方名称
        shipToAreaCode:null, // 送达方地区编码
        invoiceCode:null, // 开票方编码
        payerCode:null, // 付款方编码
        currencyCode:null, // 币种编码
        orderPrice:null, // 订单总价
        exchange:null, // 对人民币的汇率
        orderPriceRbm:null, // 订单总价rmb
        orderPriceXj:0, // 订单现金占用
        creditid:null, // 信贷id
        orderPriceXd:0, // 订单信贷占用
        orderNetWorth:null, // 订单净价值
        poId:null, // PO号
        areaId:null, // 区域详情表关联id
        dcCode:null, // 配送中心编码
        toProvincesCode:null, // 送达省份编码
        toCityCode:null, // 送达城市编码
        note:null, // 订单备注
        note1:null,//产品备注
        postcode:null, // 邮政编码
        firsttelephone:null, // 第一个电话
        secondtelephone:null, // 第二电话
        extraPrice:null, // 定制加价
        customized:null, // 定制需求
        sapsended:null, // 是否已提交sap,1-是,0-否
        toAddress:null, // 收货地址
        toCompanyname:null, // 送达方公司全称
        posnr:null, // 外销:销售和分销凭证的项目号
        inco1:null, // 外销:国际贸易条款 (部分1)
        inco2:null, // 外销:国际贸易条款 (部分2)
        submitflag:null,//提交标志
        gjmytk:null, //国际贸易条款
        fktj:null, //付款条件
        categoryName:null,
        category1Name:null,
        saleGrputName:null,
        disChannelName:null,
        zcodeName:null,
        costCenter:null,
        businessReason:null,

        allNum:0,
        allhjmaozh:0,
        allhjjinzh:0,
        allhjtiji:0,

        //汇总的佣金保费运费
        allfeeyongj:0,
        allfeebaof:0,
        allfeeyunf:0,

        boxing:null,
        boxNum:null,
        attachment:null,
        overseaShname:null,
        factory:null,
      },
      selectDailishang:true,
      showshdfdialog:false,
      currentUser:null,
      ddlx:null,
      showaddProductRow:true,
      //特价
      tejieshowflag:false,
      //定制展示
      dingzhishowflag:false,

      //是否需要信贷
      needxindai:true,
      needxinjin:true,
      showFee:true,
      showIsFree:false,
      QYcountryList: [],
      // 限制收货时间不让选择今天以前的
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      priceName: "基准价",
      showwuliaodialog1:false,
      showwuliaodialog:false,
      guanliren:false,
      yxshouhou:false,
      productlist1: [],
      productList:[],
      packageTable: [],
      xmcode:null,
      dwtiji:null,
      dwzhiliang: null,

      //用户信贷list
      creditData:[],
      disabled:false,

      //是否计算信贷
      creditFlag:false,

      //现金余额
      cashBalance:0,
    }
  },
  computed:{
    xsqyStr() {
      this.disabled = false;
      if(this.order.category2Name){
        return this.order.categoryName +"/"+ this.order.category1Name +"/"+ this.order.category2Name
      }else if(this.order.category1Name){
        if(this.order.category1Name =='标准自产订单' || this.order.category1Name =='标准OEM订单' || this.order.category1Name =='国内外贸公司订单'){
          this.disabled = true;
        }
        return this.order.categoryName +"/"+ this.order.category1Name
      }
      return this.order.categoryName
    },
    xszzStr() {
      if(this.order.saleGroupCode != '' && this.order.saleGroupCode != null){
        return "["+this.order.saleGroupCode+"]"+this.order.saleGrputName
      }
    },
    fxqdStr() {
      if(this.order.zcodeName){
        return this.order.disChannelName +"/"+ this.order.zcodeName
      }
      return this.order.disChannelName
    }
  },
  watch:{
    productlist1:{
      deep: true,
      handler(newValue, oldValue) {

        console.log("列表的刷新：",newValue)
        // new big(scope.row.specialPrice || scope.row.expoPrice || scope.row.proBenchmarkPrice||0).plus(scope.row.feeyongj||0)
        // .plus(scope.row.feebaof||0).plus(scope.row.feeyunf||0).plus(scope.row.extraPrice||0)
        // .plus(scope.row.feebaof||0).plus(scope.row.feeyunf||0).plus(scope.row.extraPrice||0)
        newValue.specialPrice= parseFloat(newValue.specialPrice)||0;
        newValue.expoPrice= parseFloat(newValue.expoPrice)||0;
        newValue.proBenchmarkPrice= parseFloat(newValue.proBenchmarkPrice)||0;
        newValue.feeyongj= parseFloat(newValue.feeyongj)||0;
        newValue.feebaof= parseFloat(newValue.feebaof)||0;
        newValue.feeyunf= parseFloat(newValue.feeyunf)||0;
        newValue.extraPrice= parseFloat(newValue.extraPrice)||0;
        _.forEach(newValue,(o,i)=>{
          console.log("o.totalprice",o.totalprice,o.exchangermb);
          console.log("new big(o.totalprice)",new big(o.totalprice));
          console.log("new big(o.totalprice)",new big(o.totalprice).times(o.exchangermb).toFixed(2));
          o.totalpricermb = new big(o.totalprice).times(o.exchangermb).toFixed(2);
        });
        //计算总金额
        this.order.orderPrice = _.reduce(_.map(newValue,"totalprice"),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        this.order.orderPriceRbm = new big(this.order.orderPrice).times(this.order.exchange||0).toFixed(2);
        if(this.needxindai && this.creditFlag){
          //this.order.orderPriceXd = new big(this.order.orderPrice).times(this.order.exchange||0).toFixed(2);
          this.order.orderPriceXd = this.order.orderPrice;
        }
        //件数合计
        this.order.allNum = _.reduce(_.map(newValue,(o)=>{return new big(o.proNumber)}),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        //毛净体合计
        this.order.allhjmaozh = _.reduce(_.map(newValue,(o)=>{return new big(o.wlmaozh).times(o.proNumber||0)}),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        this.order.allhjjinzh = _.reduce(_.map(newValue,(o)=>{return new big(o.wljinzh).times(o.proNumber||0) }),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        this.order.allhjtiji = _.reduce(_.map(newValue,(o)=>{return new big(o.wltiji).times(o.proNumber||0) }),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        this.order.allfeeyongj = _.reduce(_.map(newValue,(o)=>{return new big(o.feeyongj).times(o.proNumber||0).toFixed(2) }),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        this.order.allfeebaof = _.reduce(_.map(newValue,(o)=>{return new big(o.feebaof).times(o.proNumber||0).toFixed(2) }),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        this.order.allfeeyunf = _.reduce(_.map(newValue,(o)=>{return new big(o.feeyunf).times(o.proNumber||0).toFixed(2) }),function (sum,v) {
          return new big(sum).plus(v).toString();
        },0)
        if (newValue.length == '0'){
          this.isAddress = false;
        }
        this.creditChange(this.order.creditid)
      },
    }
  },
  methods:{
    formatterZhifakufa(row, cellValue) {
      if(row.proType=='OEM') {
        //zhifakufa;//直发库发1：直发，2：库发
        if (row.zhifakufa == 1) {
          return '直发'
        } else if (row.zhifakufa == 2) {
          return '库发'
        } else {
          return ''
        }
      }else{
        return '自产'
      }
    },
    //根据国家对应的区域
    getAreaList(){
      this.areaList=[];
      this.areaUserList=[];
      this.order.businessArea=null;
      ss.OrderMainService.getAreaList(this.order.shipToAreaCode).then(rd=>{
        this.order.businessArea = rd[0].qycode;
        this.getAreaUserList();
      })
    },
    // 新增单产品相关订单数量以及成交价输入
    bindInputNum2 (list, type) {
      if (type == "CJJ") {
        list.proBenchmarkPrice = list.finalPrice;
      }
      list.jinejjz = (Number(list.finalPrice) / list.taxRate).toFixed(2);
     // list.totalprice = (Number(list.proNumber) * Number(list.finalPrice)).toFixed(2);
    },
    // 根据订单数量以及成交价输入
    bindInputNum (row, index, type) {
      if (type == "CJJ") {
        row.proBenchmarkPrice = row.finalPrice;
      }
      row.jinejjz = (Number(row.finalPrice) / row.taxRate).toFixed(2);
      row.totalprice = (Number(row.proNumber) * Number(row.finalPrice)).toFixed(2);
      this.getCountData(index);
    },
    keyupEvent(e,input){
      e.target.value=e.target.value.replace(/[^\d.]/g, '');
      e.target.value=e.target.value.replace(/\.{2,}/g, '.');
      e.target.value=e.target.value.replace(/^\./g, '0.');
      e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
      e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
      e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
      this.input=e.target.value
    },
    changeFktj(o){
      //重置信贷
      this.order.creditid='';
      this.order.orderPriceXd = 0;
      this.needxinjin = true;
      this.needxinjin = true;
      this.setFkfsXindai(o.code);
    },
    setFkfsXindai(fkfs){
      // HT02: T/T Advance
      // LC50: 信用证
      // fjksnotjy:['HT02','LC50'],
      if(_.includes(['HT02','LC50','LCHY','LC5M'], fkfs)){
        //信用证
        if(fkfs == "LC50" || fkfs == "LCHY"|| fkfs == "LC5M"){
          this.shifouxinyzh = true;
          this.needxinjin = false;
        }else{
          this.shifouxinyzh = false;
        }
        this.needxindai=false;
      }else{
        // 有个付款方式，TT只用现金，不能选信贷，
        // 只能用信贷，不能用现金
        this.needxinjin = false;
        this.needxindai = true;
        this.shifouxinyzh = false;
        this.getCredit()
      }
    },
    //查询用户，用户余额，所有信贷
    getCredit(gscode) {
      this.creditData = [];
      this.cashBalance = 0;
      if(this.order.soldToCode && this.order.fktj){
        var params={};
        //列表中的第一个的产品大类
        var cpdl = _.uniq(_.map(this.productlist1,"proModelCode"));
        if(cpdl.length == 1){
          params.cpdlcode = cpdl[0];0
        }
        params.salegroupcode = this.order.saleGroupCode;
        params.usercode = this.order.soldToCode;
        params.fktj = this.order.fktj; // 付款提交
        return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
          console.log(rd)
          this.creditData = rd.xd;
          this.cashBalance = rd.xj ? (rd.xj.cashBalance || 0) : 0;
          // this['order'+gscode].creditData=rd.xd;
          // this['order'+gscode].xianjye=rd.xj.cashBalance||0;
        })
      }
    },
    //选择售达方
    openShoudf(){
      this.showshdfdialog = true;
    },
    // changeflag:是否已选择售达方改变
    choseshoudf(obj,changeflag){
      console.log("选择的售达方：",obj);
      // 清空物料
      if(this.order.soldToCode != obj.usercode){
        this.productlist1 = [];
      }
      this.order.soldToName = obj.username;
      this.order.soldToCode = obj.usercode;
      this.order.soldToAreaCode = obj.area;
      this.order.soldToAreaName = obj.areaname ;
      // this.order.gjmytk=obj.gjmytk; //国际贸易条款
      // this.order.fktj=obj.fktj; //付款条件
      this.order.currencyCode = changeflag ? this.order.currencyCode: obj.currency ;
      // 获取对人民币的汇率z
      if(this.order.currencyCode!='CNY'){
        ss.OrderMainService.getExchange({fromCurrency:this.order.currencyCode,toCurrency:"CNY"}).then(rd => {
          this.order.exchange = rd;
        })
      }else{
        this.order.exchange = 1
      }
      this.order.inco2 =  obj.gjmytk2;
      this.showshdfdialog = false
    },
    //有国家大区的送达方
    showQycountry(){
      ss.OrderMainService.showQycountry().then(rd=>{
        this.QYcountryList = rd;
      })
    },
    //当国际贸易条款为FOB和EXW时，去除产品信息列表保费、运费两列显示
    ruleC(){
      if (this.order.gjmytk == 'FOB' || this.order.gjmytk == 'EXW') {
        //console.log("条件进入？")
        this.showFee = false;
        if(this.productlist1 && this.productlist1.length>0){
          for(var i=0;i<this.productlist1.length;i++){
            var o = this.productlist1[i];
            o.feeyunf = 0;
            o.feebaof = 0;
          }
        }
      } else {
        this.showFee = true;
      }
    },
    //币种改变的时候
    changeCurrencyCode(o){
      // 如果存在行项目
      this.productlist1 = [];
    },
    getOrder(id){
      console.log("订单信息0：",this.order);
      ss.OrderMainService.selectById(id).then(rd=>{
        console.log("订单信息1：",rd);
        _.assign(this.order,rd.obj)
        console.log("订单信息2：",this.order);

        this.ddlx = this.order.orderCategory+","+(this.order.orderCategory1||'');
        console.log('我在这儿呀11', this.ddlx);
        var type = this.order.orderCategory1||'';
        //项目编码
        this.xmcode = this.order.orderProjectCode;

       /* if(this.order.kucun == null || this.order.kucun == ''){
          if(this.order.orderCategory == '2' && this.order.orderCategory1 == '24'){
            // if(rd.obj.products.length > 0 && (rd.obj.products[0].factory == '1RK0' || rd.obj.products[0].factory == '1R60'|| rd.obj.products[0].factory == '0PN0')){
            //   this.order.kucun = "0098";
            // }else {
            //   this.order.kucun = "0099";
            // }
          }else if(this.order.orderCategory == '2' && this.order.orderCategory1 == '21'){
            //标准自产订单，产地是1RK0时，库位0098,产地6200时，库位0099
            // if(rd.obj.products.length > 0 && rd.obj.products[0].factory == '1RK0'){
            //   this.order.kucun = "0098";
            // }else if(rd.obj.products.length > 0 && rd.obj.products[0].factory == '6200'){
            //   this.order.kucun = "0099";
            // }else {
            //   this.order.kucun = "0089";
            // }
          } else {
            this.order.kucun = "US01";
          }
        }
*/
        //免费订单
        if (type == '23') {
          this.showIsFree = true;
          ss.OrderMainService.getCostCenterList({companyCode:this.order.saleGroupCode}).then(rd=>{
            this.costList = rd;
          })
          //    改制订单
        } else if (type == '22') {
          //    改制订单
          this.dingzhishowflag = true;
        }
        //付款条件
        this.setFkfsXindai(this.order.fktj);

        // --------获取完售达方，在设置行项目行项目
        if(rd.obj.products && rd.obj.products.length>0){
          //如果免费订单 成本中心赋值
          if (type == '23') {
            this.order.costCenter = rd.obj.products[0].costCenter;
          }
          //加载完现金跟信贷，在插入行项目
          Promise.all([this.getCredit()]).then(()=>{
            rd.obj.products.forEach((obj)=>{
              if(obj){
                if(!this.order.sapCode){
                  this.order.sapCode=obj.sapCode;
                }
                obj.extraPriceN = obj.extraPrice;
                this.addProject(obj)
              }
            })
            //重新获取一遍信贷
            this.getCredit();
          })
        }
        //已有经销商
        if(this.order.soldToCode){
          ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd=>{
            this.choseshoudf(rd,true);
          })
        }
        this.ruleC();
      })
    },
    //选择物料
    showProcuct1() {
      if (this.order.shipToAreaCode == null || this.order.shipToAreaCode == '') {
        this.$msg.msge("送达方区域不可为空！");
        return;
      }
      this.showwuliaodialog = true;
    },
    //选择物料
    bindChoseWuliao(objs) {
      this.isAddress = false;
      var mateList = [];
      for(var j=0;j<objs.length;j++){
        mateList.push(objs[j].matecode);
      }

      ss.declaration.checkMaterial(mateList).then(rd => {
        if(rd.f){
          for(var i=0;i<objs.length;i++){
            //校验是否有报关名称
            if(!objs[i].customsName){
              this.$message.error("报关名称为空，请先在海外报关主数据维护" + objs[i].matecode + "的中文名称！");
              return ;
            }
            if(this.order.orderCategory1 == '23'){
              //根据产地获取销售组织
              if(objs[i].factory == '9393'){
                this.order.saleGroupCode = '9390';
              }else {
                this.order.saleGroupCode = objs[i].factory;
              }
              this.order.saleGrputName = this.$store.getters.dictname("YLSalesOrganization_agent",this.order.saleGroupCode);
              this.order.disChannelCode = '00';
              this.order.disChannelName = this.$store.getters.dictname("fenxiao_qudao",this.order.disChannelCode);

              ss.OrderMainService.getCostCenterList({companyCode:this.order.saleGroupCode}).then(rd=>{
                this.costList = rd;
                this.order.costCenter = rd.obj.products[0].costCenter;
              })
            }

            var wl = this.wlToProject(objs[i]);
            //添加行项目
            this.addProject(wl)
            this.showwuliaodialog1 = false;
            //判断是否需要填写收货地址
            //如果是oem标准订单,免费订单,产品是oem并且产地是6200发货方式为直发,收货地址必填
            if( this.order.orderCategory1 == '23' ||  this.order.orderCategory1 == '24'){
              if(objs[i].protype == 'OEM' && objs[i].delivery_method == '1'){
                this.isAddress = true;
              }
            }
            this.getKuwei(wl);
          }
          // 查询信贷（有部分是专属信贷）
          this.getCredit();
        }
      })
      this.showwuliaodialog = false;
    },
    wlToProject (bom) {
      console.log(bom, '11111111111')
      // let obj = this.packageTable[0] || {};
      // console.log(obj, '222222222222')
      var wl = {};
      wl.id = this.$util.getUuid();
      wl.materialCode = bom.matecode; //产品编码
      wl.materialName = bom.matedes; //产品名称
      wl.proModelCode = bom.cpdlcode; //产品型号编码
      wl.proModelName = bom.cpdlname; //产品型号名称
      wl.proNumber = 0
      wl.tcProNum = 0
      wl.extraPrice = null; // 定制加价
      wl.extraDes = null; // 定制需求
      wl.cwddh = null;
      wl.proType = bom.protype; //自产还是oem

      wl.fromtype = bom.fromtype;
      wl.cpz = bom.cpz; //产品组
      wl.dwcode = bom.dwcode; //单位
      wl.dwname = bom.dwname; //单位
      wl.currencyCode = bom.currency; //币种编码

      //毛净体
      wl.wlmaozh = bom.wlmaozh ; //毛重-->
      wl.wljinzh = bom.wljinzh ; //净重-->
      wl.wlzhongldw = bom.wlzhongldw; //重量单位-->
      wl.wltiji = bom.wltiji ; //体积-->
      wl.wltijidw = bom.wltijidw; //体积单位-->

      //对人民币的汇率
      wl.exchangermb = this.order.exchange;
      //公司
      wl.gscode = this.order.saleGroupCode;
      wl.proType=bom.protype; //自产还是oem

      //产地
      wl.factory=bom.factory;
      //报关名称
      wl.customsName=bom.customsName;
      //长宽高
      wl.measure=bom.MEASURE;
      //OEM产品描述
      wl.oemDesc = bom.oemDesc;

      wl.cpz = bom.cpz; //产品组
      wl.materialType = bom.materialType;
      //如果是44u0 45K0
      if(bom.factory == '44U0' || bom.factory == '45K0'){
        if(bom.materialType == 'HALB'){
          wl.cpz = 'NA';
        }else if(bom.materialType == 'ROH'){
          wl.cpz = 'ND';
        }
      }
      wl.tianman = false;
      if(this.guanliren&wl.proType=='OEM'){
        //根据产品种类判断是不是直发,如果产品层级
        if(bom.productHierarchy != null && bom.productHierarchy != ''){
          if(bom.productHierarchy.includes("YX1E33") || bom.productHierarchy.includes("YX1J26") ||bom.productHierarchy.includes("YX1J27")){
            wl.zhifakufa = 2
            wl.tianman = true;
          }else {
            wl.zhifakufa = 2
          }
        }else {
          wl.zhifakufa = 2
        }
      }

      wl.cgprice = bom.cgprice || '' //采购价
      wl.cgmll = bom.cgmll || '' //采购毛利率
      wl.tjlist = bom.tjlist || '' //特价list
      wl.expoPrice = bom.expoPrice || '';
      //样品机库位是不是单独取?
      wl.factory = bom.factory;

      wl.cpdlcode = bom.cpdlcode;
      //套餐单个产品的成交价
      wl.tcProPrice = 0;
      wl.proBenchmarkPrice = bom.jizhj
      //成交价
      wl.finalPrice = bom.jizhj || 0
      // wl.totalprice = (Number(bom.finalPrice) * Number(bom.num)).toFixed(2);
      // wl.taxCode = obj.shuilv;
      //税率
      // if (obj.shuilv == "JC") {
      //   wl.taxRate = 1.13;
      //   wl.taxCat = 3; //税分类
      // } else if (obj.shuilv == "JQ") {
      //   wl.taxRate = 1.06;
      //   wl.taxCat = 7; //税分类
      // } else if (obj.shuilv == "J5") {
      //   wl.taxRate = 1.09;
      //   wl.taxCat = 6; //税分类
      // } else {
      //   this.$msg.msge("税率查询有误！");
      //   return;
      // }
      if(bom.fromtype == 'fw' || bom.isFw == '1'){
        if (bom.taxCat == '3' || bom.taxCat == '2') {
          wl.taxCode = 'JC';
        } else if (bom.taxCat == '7') {
          wl.taxCode = 'JQ';
        } else if (bom.taxCat == '0') {
          wl.taxCode = 'J0';
        } else if (bom.taxCat == '6') {
          wl.taxCode = 'J5';
        }
        //税率
        if (bom.taxCat == '2' || bom.taxCat == '3' || bom.taxCat == '4') {
          wl.taxRate = 1.13;
        } else if (obj.taxCat == '7') {
          wl.taxRate = 1.06;
        } else {
          wl.taxRate = 1;
        }
      }

      if (bom.taxCat != null && bom.taxCat != '') {
        wl.taxCat = bom.taxCat;//税分类
      } else {
        uni.showToast({
          title: '税分类不能为空！',
          icon: 'none',
          duration: 2000
        })
        return;
      }
      //税率
      if (wl.taxCat == '2' || wl.taxCat == '3' || wl.taxCat == '4') {
        wl.taxRate = 1.13;
      } else if (wl.taxCat == '7') {
        wl.taxRate = 1.06;
      } else {
        wl.taxRate = 1;
      }
      if(bom.taxRate != null && bom.taxRate != ""){
        wl.taxRate = bom.taxRate;//税分类
      }
      //套餐相关
      // wl.lianqunName = obj.lianqunName;
      // wl.lianqunCode = obj.lianqunCode;
      // wl.sceneCode =
      //   obj.sceneCode + (obj.childSceneCode ? "#" + obj.childSceneCode : "");
      // wl.sceneName =
      //   obj.sceneName + (obj.childSceneName ? "#" + obj.childSceneName : "");

      // wl.packageName = obj.packageName;
      // wl.packageNum = 1
      // wl.packageCode = obj.packageCode;
      // wl.packagePrice = obj.packagePrice;
      // wl.isWhole = obj.isWhole;
      wl.jishu = bom.jishu;
      wl.xiaoe = bom.xiaoe;
      wl.lianqun = bom.lianqun;
      if (bom.isTj == 1) {
        wl.specialOfferCode = bom.specialOfferCode;
        wl.specialPrice = bom.finalPrice;
      }
      wl.oemDesc = bom.oemDesc;
      wl.tjlist = []
      wl.yidishpyj = null
      wl.orderField = 1
      console.log(wl, '222222');
      wl.jinejjz = (Number(wl.finalPrice) / Number(wl.taxRate)).toFixed(2).toString();
      wl.totalprice = (Number(wl.finalPrice) * Number(wl.proNumber)).toFixed(2).toString();
      console.log(wl, '333333333')
      return wl;
    },
    wlToProjectTc (obj) {
      //判断产品是否有对应的定价信息
      for (var i = 0; i < obj.bomDetailList.length; i++) {
        var wl = {};
        var bom = obj.bomDetailList[i];
        console.log(i, bom)
        // this.cpdlcode = bom.proModelCode
        wl.id = this.$util.getUuid();
        wl.materialCode = bom.prodcode;//物料编码
        wl.materialName = bom.promodel;//物料名称
        wl.proModelCode = bom.proModelCode;//产品型号编码
        wl.proModelName = bom.proModelName;//产品型号名称
        wl.proNumber = Number(bom.num) * Number(obj.packageNum);
        wl.tcProNum = bom.num;
        wl.extraPrice = null; // 定制加价
        wl.extraDes = null; // 定制需求
        wl.cwddh = null;
        wl.proType = bom.protype; //自产还是oem
        // wl.totalprice = 0;//产品总价
        wl.finalPrice = 0;

        wl.fromtype = bom.fromtype;
        wl.cpz = bom.cpz; //产品组
        wl.dwcode = bom.dwcode;//单位
        wl.dwname = bom.dwname;//单位
        wl.currencyCode = bom.currency;//币种编码

        wl.cgprice = bom.cgprice; //采购价
        wl.cgmll = bom.cgmll; //采购毛利率
        wl.tjlist = bom.tjlist;//特价list
        wl.expoPrice = bom.expoPrice;
        //样品机库位是不是单独取?
        wl.factory = bom.factory;

        wl.cpdlcode = bom.cpdlcode;
        //套餐单个产品的成交价
        wl.tcProPrice = bom.finalPrice;
        wl.proBenchmarkPrice = bom.proPrice;
        //成交价
        wl.finalPrice = bom.finalPrice;
        // wl.totalprice = new big(bom.finalPrice).times(new big(bom.num)).toFixed(2);
        wl.taxCode = obj.shuilv;
        //税率
        if (obj.shuilv == 'JC') {
          wl.taxRate = 1.13;
          wl.taxCat = 3;//税分类
        } else if (obj.shuilv == 'JQ') {
          wl.taxRate = 1.06;
          wl.taxCat = 7;//税分类
        } else if (obj.shuilv == 'J5') {
          wl.taxRate = 1.09;
          wl.taxCat = 6;//税分类
        } else {
          this.$msg.msge("税率查询有误！");
          return;
        }
        //免费订单都传9390
        if (this.ddlx == '1,6' || obj.cpdlcode == 'ND1') {
          wl.gscode = "9390";
        } else {
          wl.gscode = obj.companycode; //公司编码
        }

        this.tcGsCode = wl.gscode;
        this.zhidanGsCode = wl.gscode;

        //套餐相关
        wl.lianqunName = obj.lianqunName;
        wl.lianqunCode = obj.lianqunCode;
        wl.sceneCode = obj.sceneCode + (obj.childSceneCode ? "#" + obj.childSceneCode : "");
        wl.sceneName = obj.sceneName + (obj.childSceneName ? "#" + obj.childSceneName : "");

        wl.packageName = obj.packageName;
        wl.packageNum = obj.packageNum
        wl.packageCode = obj.packageCode;
        wl.packagePrice = obj.packagePrice;
        wl.isWhole = obj.isWhole;
        wl.jishu = bom.jishu;
        wl.xiaoe = bom.xiaoe;
        wl.lianqun = bom.lianqun;
        if (bom.isTj == 1) {
          wl.specialOfferCode = bom.specialOfferCode;
          wl.specialPrice = bom.finalPrice;
        }
        wl.oemDesc = bom.oemDesc;
        wl.tjlist = []
        wl.tianman = false;
        if(this.guanliren&wl.proType=='OEM'){
          //根据产品种类判断是不是直发,如果产品层级
          if(bom.productHierarchy != null && bom.productHierarchy != ''){
            if(bom.productHierarchy.includes("YX1E33") || bom.productHierarchy.includes("YX1J26") ||bom.productHierarchy.includes("YX1J27")){
              wl.zhifakufa = 2
              wl.tianman = true;
            }else {
              wl.zhifakufa = 2
            }
          }else {
            wl.zhifakufa = 2
          }
        }
        this.addProjectTc(wl)
      }
      // //获取信贷信息
      // Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
      //   this.companyInfoList.forEach((obj) => {
      //     this['order' + obj.code].creditid = this['order' + obj.code].creditData.length > 0 ? _.first(this['order' + obj.code].creditData).id : null;
      //     this['order' + obj.code].orderPriceXd = 0;
      //   })
      // })
    },
    addProject(obj){

      //    毛净体的单位
      if(this.dwzhiliang == null){
        this.dwzhiliang = obj.wlzhongldw||'KG';
        this.dwtiji = obj.wltijidw||'M3';
      }

      //    改制订单
      // this.dingzhishowflag = true;
      if(!this.dingzhishowflag && obj.isCustommed == '1'){
        this.dingzhishowflag = true;
      }

      if(obj.tjlist && obj.tjlist.length>0 && !this.tejieshowflag){
        this.tejieshowflag = true;

      }
      // 设置特价余量
      const checktejia = _.find(obj.tjlist,{tjdtid:obj.specialOfferCode})
      if(checktejia){
        obj.specialPriceNum=checktejia.sysl
        obj.expoPriceReadonly = true;
      }
      if(obj.materialType != null && obj.materialType != ''){
        this.getKuwei(obj);
      }
      this.productlist1.push(obj);
      // this.extraPrice1 = new big(obj.extraPrice).div(obj.proNumber).toFixed(2);
    },
    addProjectTc (obj) {
      var alllist = _.clone([...this.packageList]);
      // 不是直单的用户，如果下液氮罐的话，必须单独下单
      if (this.zhidanflag != '1' && obj.proModelCode == 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6' && this.ddlx != '1,12')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode != 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
        this.ydgFlag = true;
      }
      if (this.zhidanflag != '1' && obj.proModelCode != 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6' && this.ddlx != '1,12')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode == 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
        this.ydgFlag = false;
      }

      if (!this.order['costCenter' + obj.gscode]) {
        this.order['costCenter' + obj.gscode] = obj.costCenter || null;
      }
      //直单用户的话，全部下到9390
      if (this.zhidanflag == '1') {
        //根据用户选择公司编码 hyl
        obj.gscode = this.zhidanGsCode;
      }
      //如果是空的默认44u0
      if(null == obj.gscode || ''==obj.gscode){
        obj.gscode == '44U0'
      }
      obj.note1 = null;
      obj.jinejjz = (Number(obj.finalPrice) / Number(obj.taxRate)).toFixed(2).toString();
      obj.totalprice = (Number(obj.finalPrice) * Number(obj.proNumber)).toFixed(2).toString();
      this.packageList.push(obj);
      this.package.creditid = obj.xdid;
      this.package.gscode = obj.gscode;
      this.tcData.creditid = obj.xdid;
      this.tcData.gscode = obj.gscode;
      //测试
      // this['productlist' + obj.gscode].push(obj);
      // console.log("this.productList",this['productlist' + obj.gscode])
      // this['order' + obj.gscode].creditid = obj.xdid;
      this.tcData = this.package;

    },
    //清空已选产品列表
    cleanOrder () {
      console.log('客户渠道发生变化!')
      if (this.ddlx == '1,4') {
        return;
      }
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })
      this.productlist2 = [];

      this.companyList = [];
      this.packageTable = [];
      this.packageList = [];
      this.productlist1 = [];
    },
    deleteThis2 (index, row) {
      this.$msg.confirm("确认删除？", () => {
        this.productlist1.splice(index, 1);
      })

    },
    backtolist(){
      this.$router.go(-1);
    },
    // 选择具体的信贷
    creditChange(v){
      if(v){
        var xd = _.find(this.creditData,{id:v})
        console.log(xd)
        //现金，大于订单总额
        if(xd.quota >= this.order.orderPrice ){
          this.order.orderPriceXd = this.order.orderPrice;
          this.creditFlag = true;
        }else{
          this.$msg.msge("该信贷可用余额不足，请重新选择！");
          this.order.creditid='';
          this.order.orderPriceXd = 0;
          this.creditFlag = false;
          return;
        }
      }else{

        this.order.creditid='';
        this.order.orderPriceXd = 0;

        this.creditFlag = false;
      }

    },
    saveOrSubmit(v){

      let countryList = this.$store.getters.dictlist("YLCountry_agent");
      //提交时校验是否过期送达方区域
      let countryName = _.find(countryList,{code:this.order.shipToAreaCode}).name;
      if(countryName.indexOf('停用')!=-1){
        this.$msg.msge("送达方区域已停用请重新选择！");
        return;
      }

      this.order.orderStatus=v
      var sumFlag = false
      var factory = this.productlist1[0].factory;
      // 校验是否大于预测剩余数量
      var type = this.order.orderCategory1||'';
      this.productlist1.forEach((item,index) => {
        if(item.factory == '' || item.factory == null){
          this.$msg.msge("产地不能为空！");
          sumFlag = true;
          return;
        }
    /*    if(item.factory != factory){
          this.$msg.msge("所选产品产地不唯一，不允许提交！");
          sumFlag = true;
          return;
        }*/
        //如果是oem标准订单,免费订单,产品是oem并且产地是6200发货方式为直发,收货地址必填
     /*   if(type == '24' || type == '23'){
          if(item.factory == '6200' && item.proType == 'OEM'
                  && item.zhifakufa == '1' && (this.order.toAddress == '' || this.order.toAddress == null)){
            this.$msg.msge("请填写收货地址！");
            sumFlag = true;
            return;
          }
        }*/

      });
      // 校验是否大于特价余量
      // this.productlist1.forEach((item,index) => {
      //     if(item.proNumber > item.specialPriceNum){
      //         this.$msg.msge("编号为: " + item.materialCode + " 的产品下单数量大于特价余量,请重新操作!");
      //         sumFlag = true;
      //         return;
      //     }
      // });
      if(sumFlag){
        return;
      }
      // var sfdxy = _.every(this.productlist1,function(o) {
      //     return o.ycavailableNum>proNumber; })

      if(v=='10'){
        this.order.submitflag='暂存'
      }else if(v=='20'){
        this.order.submitflag='提交'
      }
      if(this.order.shipDate=='' || this.order.shipDate==null){
        this.$msg.msge("船期不能为空")
        return
      }
      //循环设置
      // _.forEach(this.productlist1,(value)=>{
      // 	value.costCenter = this.order.costCenter;
      //     value.extraDes = _.join(value.extraDesids||[],",");
      // });

 /*     for(var i=0;i<this.productlist1.length;i++){
        var value = this.productlist1[i];
        value.costCenter = this.order.costCenter;
        if (value.specialPrice == null || value.specialPrice == '') {
          if(((value.expoPrice - value.extraPrice||0) < value.proBenchmarkPrice) && !this.showIsFree && !this.isYX){
            this.$msg.msge("第"+(i+1)+"行，销售单价:"+value.expoPrice+"（成交价-运保佣-定制加价）要高于基准价，若不满足条件，请申请特价");
            return;
          }
        }
      }*/

      this.order.products = this.productlist1;
      if(this.order.submitflag=='提交'){

        //免费订单
        var freeflag = true;
        if(this.showIsFree){
          this.$refs['form0'].validate((valid0)=>{
            freeflag = valid0;
          })
        }
        if(this.needxindai && this.order.orderCategory1 != '23'){
          if(this.order.creditid == '' || this.order.creditid == null){
            this.$msg.msge("请选择信贷后再提交！");
            return;
          }
        }
        //国际贸易条款为CIF时，运费和保险不能为0
        var ybFlag = true;
        if(this.order.gjmytk == 'CIF' && this.order.orderCategory1 != '23'){
          for(var i=0;i<this.productlist1.length;i++) {
            var value = this.productlist1[i];
            if(value.specialOfferCode || (value.feebaof > 0 && value.feeyunf > 0)){
              ybFlag = false;
            }
          }
          if(ybFlag){
            this.$msg.msge("国际贸易条款为CIF时,运费保费不能为0！");
            return;
          }
        }

        this.$refs['form1'].validate((valid1) => {
          if (valid1 && freeflag) {
            this.$msg.confirm("确认提交？",()=>{
              this.submitForm();
            })
          }else{
            this.$msg.msge("请完善基本信息后提交");
            return;
          }
        });

      }else{
        this.submitForm();
      }
    },
    submitForm(){
      this.submitChongfuFlag = false;
      ss.OrderMainService.saveOrSubmit(this.order).then(rd=>{
        this.submitChongfuFlag = true;
        if(rd.f) {
          if (this.order.submitflag == '提交') {
            this.$msg.msgs("提交成功！")
            this.$router.push({path: '/dingd/dingdwxlist'})
          } else {
            this.$msg.msgs("暂存成功！")
          }
        }else{
          this.$msg.msge(rd.msg);
        }
      })
    },
    //自动选择库位
    getKuwei(wl){
      if(wl.proType=='OEM'){
        if(wl.factory=='1RK0' || wl.factory=='1R60'|| wl.factory=='0PN0' ){
          wl.kucun = "0098";
        }else if(wl.factory=='1S00' || wl.factory=='1S40') { //厚宏 OEM 0099
          wl.kucun = "0099";
        }else if(wl.factory=='44U0' || wl.factory=='45K0') { //元析 OEM 0098
          //售后的订单传SH00
          if(this.yxshouhou){
            wl.kucun = "SH00";
          }else {
            wl.kucun = "0099";
          }
        }else {
          wl.kucun = "0099";
        }
      }else{
        if(wl.factory=='9370'){
          wl.kucun = "7089";
        }else if(wl.factory=='6200'){
          wl.kucun = "0099";
        }else if(wl.factory=='1RK0'){
          wl.kucun = "0098";
        }else if((wl.factory=='0PN0' && wl.gscode=='6200') || (wl.factory=='0PN0' && wl.gscode=='9390')){
          wl.kucun = "9089";
        }else if(wl.factory=='1S00' || wl.factory=='1S40') { //厚宏 自产 0088
          wl.kucun = "0088";
        }else if(wl.factory=='44U0' || wl.factory=='45K0') { //元析 自产 0088
          wl.kucun = "0088";
        }else{
          wl.kucun = "0089";
        }
      }
      if(wl.factory=='44U0' || wl.factory=='45K0') {
        if(wl.materialType=='HALB'){
          wl.kucun = "0066";
        }else if(wl.materialType=='ROH'){
          wl.kucun = "7011";
        }else if(wl.materialType=='UNBW'){
          wl.kucun = "";
        }
      }
    },
  },
  created() {
    let id = this.$route.query.ywid;
    let instid = this.$route.query.instid;
    let taskid = this.$route.query.taskid;
    let taskstatus = this.$route.query.taskstatus|0;

    // 当前权限
    this.guanliren = this.$store.getters.hasRole("swyl_xiaoshoujl_yx,yx_shouhoujl,swyl_xiaoshoujl_yx_wx,swyl_admin,yx_wxzuhe");

    this.yxshouhou = this.$store.getters.hasRole("yx_shouhoujl");

    let chongXinTiJiao = this.$route.query.chongXinTiJiao;
    //代办打开的
    if(id && instid){
      this.resubmit = true;

      //如果不是重新提交,则不能添加跟删除了
      if(!chongXinTiJiao){
        this.showaddProductRow = false;
        //this.showdelProductRow = false;
      }

      this.instid = instid;
      this.taskstatus = taskstatus;
      this.order.taskId = taskid;
      if(taskstatus == '1'){
        // 直接设置经销商
        this.selectDailishang = false;
        const parent = document.querySelector(".input");
        parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
        //2.在设置input属性
        //获取input
        const input = document.querySelector(".input input");
        //设置input的属性为false
        input.disabled = false;
      }
    }
    this.getOrder(id||this.$route.query.id);
    this.showQycountry();
  }
}
</script>
<style scoped>
.queren {
  background-color: #006aca;
  color: white;
}

.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.zancun {
  background-color: #24b5b8;
  color: white;
}

.quxiao, .zancun {

  width: 100px;
}
.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}
.jieguo .jieguo_label{
  width: 2rem;
  text-align: right;
  background-color: #ebf5ff;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.05rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jieguo .jieguo_value{
  width: 20%;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0px 8px;
}
img {
  width: 25px;
  padding: 5px 0;
  margin-left: 8rem;
}

.newProject {
  margin: 0 20px;
  background-color: rgb(94, 182, 233);
}
.h-piece {
  margin: 20px;
}
.DshuR {
  width: 100%;
  height: 100%;
  border: none;
}


.message {
  padding: 20px 0;
  margin-bottom: 0;
  background-color: white;
}

.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}

.el-cascader {
  line-height: normal;
}
</style>
<style>
.n-two .h-formbLine .el-form-item__content .el-select,
.n-two .el-form .h-formbLine .el-form-item__content .el-select {
  width: 0;
}

.n-xiao .h-formbLine .el-form-item__label,
.n-two .h-formbLine .el-form-item__label {
  width: 43%;
}

.n-xiao .h-formbLine .el-form-item__content,
.n-two .h-formbLine .el-form-item__content {
  width: 57%;
}


/* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
    content: "全选";
    color: white;
    background-color: rgb(93, 172, 236);
    font-size: 10px;
} */
.ljjtablepaddings3 .h-tableInput .el-input__inner{
  padding: 0.05rem 0.1rem;
}
.ljjtablepaddings3 .h-tableInput .el-input__icon{
  line-height: 0.25rem;
}
.ljjtablepaddings3 .ljjsales .el-input__inner{
  height: 0.3rem;
}
.ljjtablepaddings3 .ljjsales .el-input__icon{
  line-height: 0.42rem;
}
</style>

<style scoped lang="scss">
.areaSelect {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 2019;

  .centerBlock {
    width: 700px;
    height: 400px;
    padding: 20px;
    border-radius: 20px;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.dingzhicss{
  font-size: 12px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>
<style>
.aaa .el-dialog__headerbtn {
  display: none;
}
.ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
  color: #868686;
}
</style>
